import { PriceIndexEnum } from 'api';
import { useFormContext, useWatch } from 'react-hook-form';
import * as yup from 'yup';

import { PriceAndCurrencyField } from '../PriceAndCurrencyField/PriceAndCurrencyField';
import { PriceAsIndex } from '../PriceAsIndex/PriceAsIndex';
import { SwitchField } from '../SwitchField/SwitchField';

type Props = {
  priceName?: string;
  currencyName?: string;
  label?: string;
};

export const defaultPriceIndexSchema =
  PriceIndexEnum &&
  yup.object({
    price_as_index_pct_enabled: yup.boolean().optional(),
    price_as_index_percentage: yup.number().when('price_as_index_pct_enabled', {
      is: (indexPctEnabled: boolean) => {
        return indexPctEnabled;
      },
      otherwise: () => yup.number().notRequired(),
      then: () => yup.number().integer().min(0).max(100).required('This field is required'),
    }),
    price_as_index_percentage_fixed_on_date_options: yup.string().when('price_as_index_pct_enabled', {
      is: (indexPctEnabled: boolean) => {
        return indexPctEnabled;
      },
      otherwise: () => yup.string().notRequired(),
      then: () => yup.string().required('This field is required'),
    }),
    price_as_index_percentage_fixed_on_date_other_details: yup
      .string()
      .when('price_as_index_percentage_fixed_on_date_options', {
        is: (option: string) => {
          return option === 'other';
        },
        otherwise: () => yup.string().notRequired(),
        then: () => yup.string().required('Value must be provided if when to fix is set as other'),
      }),
    price_as_index_percentage_fixed_on_options: yup.string().when('price_as_index_pct_enabled', {
      is: (indexPctEnabled: boolean) => {
        return indexPctEnabled;
      },
      otherwise: () => yup.string().notRequired(),
      then: () => yup.string().required('This field is required'),
    }),
    price_as_index_percentage_fixed_on_other_details: yup.string().when('price_as_index_percentage_fixed_on_options', {
      is: (option: string) => {
        return option === 'OTHER';
      },
      otherwise: () => yup.string().notRequired(),
      then: () => yup.string().required('Value must be provided if fixed price at is set as OTHER'),
    }),
    price_index: yup
      .string()
      .oneOf(Object.values(PriceIndexEnum))
      .when('price_as_index_pct_enabled', {
        is: (indexPctEnabled: boolean) => {
          return indexPctEnabled;
        },
        otherwise: () => yup.string().oneOf(Object.values(PriceIndexEnum)).notRequired(),
        then: () => yup.string().oneOf(Object.values(PriceIndexEnum)).required('This field is required'),
      }),
  });

export const PriceAsCurrencyOrIndex = ({
  priceName = 'price_per_tonne',
  currencyName = 'currency',
  label = 'Price per tonne',
}: Props) => {
  const form = useFormContext();
  const isPriceAsPercentEnabled = useWatch({
    control: form.control,
    name: 'price_as_index_pct_enabled',
  });
  return (
    <>
      <SwitchField name="price_as_index_pct_enabled" label="Fix price to market %" />
      {!isPriceAsPercentEnabled ? (
        <PriceAndCurrencyField priceName={priceName} currencyName={currencyName} label={label} />
      ) : (
        <PriceAsIndex />
      )}
    </>
  );
};
